import React, { useEffect, useState } from 'react';
import { Task, TaskResponse, TaskState } from 'gql/graphql';
import { CardLoanTasksProps } from 'components/Atoms/Cards/CardLoanTasks/CardLoanTasks';
import InvestmentExperienceVerification from '../InvestmentExperienceVerification/InvestmentExperienceVerification';
import { ModuleKeys } from 'services/task/modules-keys.constanst';
import CircleTag from '../../../../../components/Atoms/Tags/CircleTag/CircleTag';

interface Props {
  tasks?: Task[] | any[],
  loan?: any;
  trackRecord: any;
}

const useCardInvestment = ({ tasks, loan, trackRecord }: Props) => {

  const [dataTask, setDataTask] = useState<Task>();
  const [stepNow, setStepNow] = useState<TaskResponse>();
  const [response, setResponse] = useState<TaskResponse>();
  const [countProperties, setCountProperties] = useState<number>();

  useEffect(() => {
    if (tasks) {
      const data: Task = tasks.find((item) => item.key === ModuleKeys.INVESTMENT_EXPERIENCE);
      setDataTask(data);
      setResponse(data?.responses.find(item => item.key !== 'doc-another'));

      if (data?.responses.length > 0)
        setStepNow(data?.responses.reduce((max, obj) => obj.step > max.step ? obj : max, data?.responses[0]));
    }
  }, [tasks]);

  useEffect(() => {
    if(loan)
      setCountProperties(loan.investmentExperience?.properties === '1-2' ? 2 : 3);
  }, [loan]);

  const getFilesCircle = () => {
    const allFiles = response?.files || [];
    const count = countProperties || 0;
    
    const approved = allFiles.filter(f => f.state === 'approved');
    const notApproved = allFiles.filter(f => f.state !== 'approved');
    
    // Siempre incluir todos los approved
    const selected: any[] = [...approved];
    
    const remaining = count - approved.length;
    
    if (remaining > 0) {
      const lastNotApproved = notApproved.slice(-remaining);
      selected.push(...lastNotApproved);
    }
    
    // Si aún faltan, rellenar con DRAFT
    const draftsNeeded = Math.max(0, count - selected.length);
    if (draftsNeeded > 0) {
      selected.push(...Array(draftsNeeded).fill({ state: 'DRAFT' }));
    }
    
    return selected;
  };
  
  const getTotalApproved = () => {
    const allFiles = response?.files || [];
    const count = countProperties || 0;
    
    const approvedCount = allFiles.filter(f => f.state === 'approved').length;
    
    const notApproved = allFiles.filter(f => f.state !== 'approved');
    const remaining = count - approvedCount;
    const lastNotApproved = notApproved.slice(-remaining);
    const reviewCount = lastNotApproved.filter(f => f.state !== 'request_error' && f.state !== 'draft').length;
    
    return approvedCount + reviewCount;
  };

  const isDisabled = dataTask?.state === TaskState.ComingSoon;

  const card: CardLoanTasksProps =
  {
    key: ModuleKeys.INVESTMENT_EXPERIENCE,
    title: <h4 className={`h4 ${isDisabled && 'disabled'}`}>Investment Experience Verification</h4>,
    steps: 1,
    stepCurrent: stepNow?.step || 0,
    type: 'quick task',
    state: dataTask?.state,
    stateTooltipHtml: `<span>${'Please complete '}</span><b>Past Investment Experience</b><span> to unlock this</span>`,
    actions: dataTask
      ? [
        <InvestmentExperienceVerification
          key={1}
          task={dataTask}
          disabled={isDisabled}
        />
      ]
      : [],
    text: (
      <p className={`body-card ${isDisabled && 'disabled'}`}>
        I’ve purchased/sold {loan?.investmentExperience?.properties} real estate properties in the past 36 months
      </p>
    ),
    text2: (
      <div className='docs-section'>
        <div className='labels'>
          <p className={`body-regular body-regular-bold ${isDisabled && 'disabled'}`}>
            Document status
          </p>
          <p className={`body-card ${isDisabled && 'disabled'}`}>
            {getTotalApproved()}/{countProperties || 0} submitted
          </p>
        </div>
        <div className={`circles-tags ${isDisabled && 'disabled'}`}>
          {getFilesCircle().map((file, index) => {
            let _state = file.state?.toUpperCase() || 'DRAFT';
            
            return (<CircleTag
              key={index}
              state={_state}
              tagKey={_state}
              isIconState={true}
            />);
          })}
        </div>
      </div>
    )
  };

  if(!dataTask) 
    return { card: null };
  
  return {
    card,
    dataTask
  };
};

export default useCardInvestment;